import { render, staticRenderFns } from "./create-budget.vue?vue&type=template&id=3e93387d&scoped=true"
import script from "./create-budget.vue?vue&type=script&lang=js"
export * from "./create-budget.vue?vue&type=script&lang=js"
import style0 from "./create-budget.vue?vue&type=style&index=0&id=3e93387d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e93387d",
  null
  
)

export default component.exports